export const filtersLabels = {
  checkIn: 'Check-In Date',
  checkInInstructionsIssues: 'CI Instructions Issues',
  checkInInstructionsLastSent: 'CI Instructions Last Sent',
  checkInInstructionsStatus: 'CI Instructions Status',
  checkOut: 'Check-out',
  creationDate: 'Creation Date',
  cancellationCreationDate: 'Cancellation Date',
  depositsOnHold: 'Security Deposit on Hold',
  earlyCheckInStatus: 'ECI Status',
  isRepeated: 'Repeat Bookings Only',
  leadSource: 'Lead Source',
  longTerm: 'Long Term',
  market: 'Market',
  pendingRequests: 'Pending Service Requests',
  riskLevel: 'Property Risk',
  status: 'Status',
  tags: 'Type',
  totalPrice: 'Total Price',
  reservationType: 'Reservation Type',
  bookingRiskStatus: 'Booking Risk Status',
  acquisition: 'Acquisition',
  leadTime: 'Lead Time',
  auditStatus: 'Audit Status',
  paymentPlan: 'Payment Plan',
  paymentPlanDate: 'Payment Plan Date',
  followUpDate: 'Follow Up Date',
  updatedBy: 'Updated By',
  auditPaymentNotes: 'Audit Payment Notes',
  balanceMin: 'Balance Min',
  balanceMax: 'Balance Max',
  viewFrom: 'View From',
  availableDates: 'Available Dates',
  guestsRange: 'Guests',
  minBedroom: 'Min. Bedrooms',
  minBathrooms: 'Min. Bathrooms',
  bedroomsRange: 'Bedrooms',
  bathroomsRange: 'Bathrooms',
  addressRadius: 'Proximity to Location',
  reasons: 'Reason',
  petsCount: 'Pets',
  guestsCount: 'Guests',
  serviceIds: 'VAS',
  b2b: 'B2B (Pre-Arrival)',
  dateRange: 'Date Range',
  cleanCreated: 'Clean Created',
}
